import { render, staticRenderFns } from "./categ_products.vue?vue&type=template&id=34e09d8a&scoped=true&"
import script from "./categ_products.vue?vue&type=script&lang=js&"
export * from "./categ_products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e09d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e09d8a')) {
      api.createRecord('34e09d8a', component.options)
    } else {
      api.reload('34e09d8a', component.options)
    }
    module.hot.accept("./categ_products.vue?vue&type=template&id=34e09d8a&scoped=true&", function () {
      api.rerender('34e09d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/categories/category/tabs/categ_products.vue"
export default component.exports